<template lang="pug">
  v-container.policy.mx-auto
    h2.policy__title.text-center.mb-8 Standard privacy
    p.policy__para
      | The personal data collected in the context of E-Order are processed by
      | the Geodis SCO Services data controller, whose registered office is
      | located at 26 quai Charles Pasqua? Levallois Perret.
    h3.policy__subtitle Purpose of the data processing
    p.policy__para
      | The purpose of the data processing is to perform client management
      | operations.
    h3.policy__subtitle Lawfulness of processing
    p.policy__para
      | This data processing relates to the legitimate interest<sup>1</sup> of GEODIS or
      | its entities to perform its Operations in relation with a contract the
      | data subject is party.
    h3.policy__subtitle Categories of data processed
    p.policy__para
      | The categories of personal data directly collected by Geodis are as
      | follows:
    ul.policy__list
      li.policy__bullet Name
      li.policy__bullet Adress
      li.policy__bullet E-mail
      li.policy__bullet Phone number
    h3.policy__subtitle Mandatory or optional nature of data collection
    p.policy__para
      | The collection of data is necessary for the execution of this
      | processing operation.
    h3.policy__subtitle Automated decision making
    p.policy__para The processing does not provide for automated decision making.
    div.mb-8
    h3.policy__subtitle Data subjects
    p.policy__para The data processing concerns:
    ul.policy__list
      li.policy__bullet
        | For GEODIS, the concerned data subjects may be, for example,
        | employees having a user account.
      li.policy__bullet
        | For the data processor, the data subjects may be, for example,
        | the authorized persons involved in the provision of services.
    h3.policy__subtitle Data recipients
    p.policy__para
      | The personal data collected are exclusively intended for Geodis SCO
      | entities.
    h3.policy__subtitle Cross-border data transfers
    p.policy__para
      | Data transfers outside the European Union are made to the following
      | countries: Serbia, Switzerland, China, India, Mexico.
    h3.policy__subtitle Data retention period
    p.policy__para
      | The personal data collected will be kept for 3 years after inactivity
      | of data.
    hr.my-8
    h3.policy__subtitle About your rights
    p.policy__para
      | Pursuant to the applicable laws and regulations on personal data, you
      | have the right [not to give your consent] <sup>2</sup>or the right to access,
      | rectify, object to, limit the processing, erase and to data portability,
      | which you may exercise by e-mail to the address dpo@geodis.com by post
      | to GEODIS 26 Quai Charles Pasqua, 92309 Levallois-Perret, specifying
      | your full name and the subject of your action. If you feel that the
      | DPO's response is not satisfactory, you can file a complaint by post
      | with the CNIL – Commission Nationale de l’Informatique et des Libertés
      | or online www.cnil.fr
    hr.my-8
    p.policy__para.font-weight-bold
      | Note: in case of sensitive data processing or potentially intrusive
      | processing (such as geolocation, targeting), please ensure that the
      | level of transparency of the information is increased and that the
      | privacy notice is reviewed by your DPO before its publication.
    div.mb-8
    h3.policy__subtitle Annex 1: Data subjects’ rights according to the legal basis.
    table.policy__table
      thead
        tr
          th(colspan="2")
          th Consent
          th Contract
          th Legitimate interest
          th Legal obligation
      tbody
        tr
          td(colspan="2") Right of access
          td.blue--text Yes
          td.blue--text Yes
          td.blue--text Yes
          td.blue--text Yes
        tr
          td(colspan="2") Right to request the rectification
          td.blue--text Yes
          td.blue--text Yes
          td.blue--text Yes
          td.blue--text Yes
        tr
          td(colspan="2") Right to object
          td.red--text No
          td.red--text No
          td.blue--text Yes
          td.red--text No
        tr
          td(colspan="2") Right to restriction of processing
          td.blue--text Yes
          td.blue--text Yes
          td.blue--text Yes
          td.blue--text Yes
        tr
          td(colspan="2") Right to erasure
          td.blue--text Yes
          td.blue--text Yes
          td.blue--text Yes
          td.red--text No
        tr
          td(colspan="2") Right to data portability<sup>3</sup>
          td.blue--text Yes
          td.blue--text Yes
          td.red--text No
          td.red--text No
        tr
          td(colspan="2") Right to withdrawal of consent
          td.blue--text Yes
          td.red--text No
          td.red--text No
          td.red--text No
  </template>

  <style lang="scss" scoped>
  .policy {
    padding: 100px 0;
    color: black;
    max-width: 700px;
    &__subtitle,
    &__para,
    &__list,
    &__table {
      font-size: 1rem;
      line-height: 1.2rem;
    }
    &__para,
    &__subtitle,
    &__list {
      margin-bottom: 12px;
    }
    &__table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
    }
    &__table td,
    &__table th {
      border: solid 1px black;
    }
  }
  </style>

  <script>
  export default {
    name: 'app-policy',
  };
  </script>
